<template>
  <div :class="inPopup ? '' : 'popup_in'">
    <div :class="inPopup ? '' : 'popup'">
      <div v-show="!inPopup" class="popup_close close-animate">
        <a href="javascript:void(0);" @click.prevent="$emit('close')">
          <CloseSvg />
        </a>
      </div>
      <div class="title">שליחת מסמכי ביטוח למוקד חדר ניתוח</div>

      <div v-show="!msg">
        <div
          class="flex flex--start inner_group step-4-docs-group"
          style="background-color: #e1e1dd;"
        >
          <a
            href="javascript:void(0);"
            class="file_item relative flex desk-block"
            v-for="(file, index) in files"
            :key="index"
          >
            <span @click.prevent="removeFile(index)" class="file-remove">
              <CloseSvg />
            </span>
            <img class="no_mobile" src="/assets/img/svg/ic-file.svg" />
            <span class="tx_file block">{{ file.name }}</span>
          </a>
          <div class="bt_upload relative flex desk-block">
            <input
              id="file"
              type="file"
              ref="files"
              multiple
              @change="handleFilesUpload"
            />
            <div class="ic-upload ease">
              <UploadSvg />
            </div>
            <div class="tx_file ease">הוספת מסמך</div>
          </div>
        </div>
        <div class="add_new_row flex step-4-docs-group">
          <label for="notes" class="add_new_row_col1 w-100">הערות</label>
          <div class="input_area_opcity add-border w-100">
            <textarea id="notes" name="notes" v-model="notes"></textarea>
          </div>
        </div>
        <div v-show="validationMsg" class="error-message">
          {{ validationMsg }}
        </div>
        <a class="bt_blue bt-policies" href="javascript:void(0);" @click="send">
          שלח
          <vue-loaders-ball-clip-rotate
            v-show="isLoading"
            color="white"
            scale="1.2"
            style="position: relative;top: 9px;"
          ></vue-loaders-ball-clip-rotate>
        </a>
      </div>

      <div v-show="msg">
        <div v-if="msg == 'success'">
          הקובץ נשלח בהצלחה למוקד חדר ניתוח ויטופל תוך יום עבודה.
        </div>
        <div v-else>שגיאה במערכת נסה שנית מאוחר יותר.</div>
        <a
          class="bt_blue bt-policies"
          href="javascript:void(0);"
          @click="$emit('close')"
        >
          המשך
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CloseSvg from "../../assets/img/svg/close.svg";
import UploadSvg from "../../assets/img/svg/upload.svg";
import { mapGetters } from "vuex";
import { sendPolicies } from "../../api/api-quatro";

export default {
  name: "UploadPolicies",
  components: {
    CloseSvg,
    UploadSvg
  },
  props: {
    inPopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      files: [],
      notes: "",
      msg: "",
      validationMsg: "",
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(["activeDoctor"])
  },
  methods: {
    removeFile(index) {
      this.files.splice(index, 1);
    },
    handleFilesUpload() {
      let files = this.$refs.files.files;
      for (const filesKey in files) {
        if (files[filesKey] instanceof File) {
          this.files.push(files[filesKey]);
        }
      }
    },
    async send() {
      if (this.isLoading) return;
      if (!this.files.length) {
        this.validationMsg = "נא לבחור לפחות קובץ אחד";
        return;
      }

      this.validationMsg = "";
      this.isLoading = true;
      const formData = new FormData();
      formData.append("notes", this.notes);
      formData.append(
        "doctor",
        this.activeDoctor ? this.activeDoctor.name : ""
      );
      this.files.forEach((file, index) => {
        formData.append(`files[${index}]`, file);
      });

      try {
        const res = await sendPolicies(formData);
        this.msg =
          res && res.data && res.data.status !== "error"
            ? "success"
            : "failure";
      } catch (error) {
        this.msg = "failure";
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
